<template>
  <section>
    <div class="row justify-content-center">
      <div class="col-12 col-md-4">
        <form @submit.prevent="requestOtp" v-if="!isRequestingOtp">
          <div class="form-group">
            <label for="tel">กรุณากรอกเบอร์โทรศัพท์ของคุณ</label>
            <input type="number" id="tel" v-model="tel"
                   class="form-control" required>
          </div>
          <div class="form-group">
            <button type="submit" :disabled="loading" class="btn btn-primary">SUBMIT</button>
          </div>
        </form>
        <form @submit.prevent="submitOtp" v-else>
          <div class="form-group">
            <label for="otp_input">กรุณากรอกรหัส OTP</label>
            <input type="text" id="otp_input" v-model="otp" class="form-control" required>
          </div>

          <div class="form-group">
            <button type="submit" :disabled="loading" class="btn btn-primary">SUBMIT</button>
            <button type="button" :disabled="!isTimeout"
                    @click.prevent="requestOtp" class="btn btn-success float-right">ขอรหัสใหม่
            </button>
          </div>
          <h4>Countdown: {{timerDisplay}}</h4>
        </form>

      </div>
    </div>
  </section>
</template>

<script>
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'LoginServiceTeam',
    data () {
      return {
        timerDisplay: '',
        isTimeout: false,
        loading: false
      }
    },
    computed: {
      ...mapState({
        hasLogin: state => state.ServiceTeam.hasLogin,
        isRequestingOtp: state => state.ServiceTeam.isRequestingOtp,
        member: state => state.ServiceTeam.member,
        memberId: state => state.ServiceTeam.memberId
      }),

      tel: {
        get () {
          return this.$store.state.ServiceTeam.tel
        },
        set (value) {
          this.$store.commit('ServiceTeam/UPDATE_TEL', value)
        }
      },

      otp: {
        get () {
          return this.$store.state.ServiceTeam.otp
        },
        set (value) {
          this.$store.commit('ServiceTeam/UPDATE_OTP', value)
        }
      }
    },
    methods: {
      timerOtp () {
        // นับถอยหลัง 1 นาที จะสามารถขอรหัสได้อีกครั้ง
        let countDown = moment().add({ minute: 1, second: 1 })
        this.isTimeout = false
        let counter = setInterval(() => {
          let diff = countDown.diff(moment())
          this.timerDisplay = moment(diff).format('mm:ss')

          if (diff <= 0) {
            this.timerDisplay = moment('0:00', 'm:ss').format('mm:ss')
            this.isTimeout = true
            clearInterval(counter)
          }
        }, 1000)
      },
      async requestOtp () {
        this.loading = true
        this.otp = ''
        this.$store.dispatch('ServiceTeam/SEND_OTP', this.tel).then(res => {
          this.timerOtp()
        }).catch(error => {
          this.$swal({ text: error, type: 'error' })
        }).finally(() => {
          this.loading = false
        })
      },
      async submitOtp () {
        this.loading = true
        this.$store.dispatch('ServiceTeam/SUBMIT_OTP', {
          otp: this.otp,
          member_id: this.memberId
        }).then(res => {
          this.$swal({ text: 'สำเร็จ', type: 'success' })
        }).catch(error => {
          this.$swal({ text: error, type: 'error' })
        }).finally(() => {
          this.loading = false
        })
      }
    },
    created () {
      this.$store.commit('ServiceTeam/CLEAR_DATA_STATE')
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/serviceRequest/Components/LoginServiceTeam.vue